import { createSlice } from "@reduxjs/toolkit";
import { dayNames, setEmptyDay } from "./settings";
import { FetchBookingData } from "../requests/booking";

export const TIME_DURATIONS = [15, 30, 45, 60, 90, 120];

const initialState = {
  status: null,
  title: "",
  description: "",
  duration: TIME_DURATIONS[1],
  isOnlineType: true,
  link: "",
  location: "",
  schedule: {
    id: null,
    timezones: [],
    timezone: null,
    dateStart: "",
    dateEnd: "",
    days: [
      [setEmptyDay(dayNames[0])],
      [setEmptyDay(dayNames[1])],
      [setEmptyDay(dayNames[2])],
      [setEmptyDay(dayNames[3])],
      [setEmptyDay(dayNames[4])],
      [setEmptyDay(dayNames[5])],
      [setEmptyDay(dayNames[6])],
    ],
  },
};

const booking = createSlice({
  name: "booking",
  initialState,
  reducers: {
    resetBooking() {
      return initialState;
    },
    setScheduleTimezone(state, { payload }) {
      state.schedule.timezone = payload;
    },
    setScheduleDateStart(state, { payload }) {
      state.schedule.dateStart = payload;
    },
    setScheduleDateEnd(state, { payload }) {
      state.schedule.dateEnd = payload;
    },
    addDayItem(state, { payload }) {
      const { isActive } = state.schedule.days[payload][0];
      state.schedule.days[payload].push({
        ...setEmptyDay(dayNames[payload]),
        isActive,
      });
    },
    setToggleActiveDay(state, { payload }) {
      state.schedule.days[payload] = state.schedule.days[payload].map(
        (item) => ({ ...item, isActive: !item.isActive })
      );
    },
    removeDayItem(state, { payload: { dayIndex, fieldIndex } }) {
      state.schedule.days[dayIndex] = state.schedule.days[dayIndex].filter(
        (_, i) => i !== fieldIndex
      );
    },
    resetDayField(state, { payload }) {
      const isActive = state.schedule.days[payload][0].isActive;
      state.schedule.days[payload] = [
        { ...setEmptyDay(dayNames[payload]), isActive },
      ];
    },
    setDayField(
      state,
      { payload: { dayIndex, fieldIndex, valueIndex, value } }
    ) {
      state.schedule.days[dayIndex][fieldIndex][valueIndex] = value;
    },
    applyAll(state) {
      const firstDay = state.schedule.days[0].map((item) => ({
        ...item,
        id: null,
      }));
      state.schedule.days = state.schedule.days.map((item, index) => {
        return index === 0
          ? item
          : [...firstDay.map((el) => ({ ...el, day: dayNames[index] }))];
      });
    },
    setBookingTitle(state, { payload }) {
      state.title = payload;
    },
    setBookingDescription(state, { payload }) {
      state.description = payload;
    },
    setBookingDuration(state, { payload }) {
      state.duration = payload;
    },
    setIsOnlineType(state, { payload }) {
      state.isOnlineType = payload;
    },
    setLink(state, { payload }) {
      state.link = payload;
    },
    setLocation(state, { payload }) {
      state.location = payload;
    },
    setTimezones(state, { payload }) {
      state.schedule.timezones = payload;
    },
  },
  extraReducers: {
    [FetchBookingData.pending]: (state) => {
      state.status = "load";
    },
    [FetchBookingData.rejected]: (state) => {
      state.status = "failed";
    },
    [FetchBookingData.fulfilled]: (state, { payload }) => {
      const isOnline = payload.event === "online";
      state.status = "success";
      state.title = payload.title;
      state.description = payload.description;
      state.duration = payload.duration;
      state.isOnlineType = isOnline ? true : false;
      state.link = isOnline ? payload.link : "";
      state.location = isOnline ? "" : payload.link;
      state.schedule.timezone = payload.timezone.id;
      state.schedule.dateStart = payload.dateStart.split(" ")[0];
      state.schedule.dateEnd = payload.dateEnd.split(" ")[0];
      state.schedule.days = new Array(7).fill().map((_, index) => {
        const daySchedule = payload.schedules.filter(
          (elem) => elem.day === dayNames[index]
        );
        if (daySchedule.length) {
          return daySchedule.map((el) => ({
            id: el.id,
            day: el.day,
            dateStart: el.dateStart
              ? el.dateStart.split(" ")[1].substring(0, 5)
              : "",
            dateEnd: el.dateEnd ? el.dateEnd.split(" ")[1].substring(0, 5) : "",
            isActive: el.isActive,
          }));
        } else {
          return [setEmptyDay(dayNames[index])];
        }
      });
    },
  },
});
export const {
  setScheduleTimezone,
  setScheduleDateStart,
  setScheduleDateEnd,
  addDayItem,
  setToggleActiveDay,
  removeDayItem,
  resetDayField,
  setDayField,
  applyAll,
  editLocationPoint,
  setBookingTitle,
  setBookingDescription,
  setBookingDuration,
  setIsOnlineType,
  setLink,
  setLocation,
  setTimezones,
  resetBooking,
} = booking.actions;
export default booking.reducer;
